export default {
    data(){
        return {
            trial_days_options: [7, 14, 30],
        }
    }
}
